import { useState, useContext } from "react";
import * as notify from "../notify";
import { completeTask, rejectTask } from "../taskState";
import { dialogConfirm } from "../dialog";
import { DialogRejectReason } from "../../components/task-nav/components/dialog-reject";
import { sendNote } from "../../components/notes/lib/data";
import { TaskContext } from "../../contexts/task";

export const useQaNavActions = (props) => {
    const [isBusy, setIsBusy] = useState(false);
    const { task } = useContext(TaskContext);
    const [validation, setValidation] = useState({
        isValidationConfirmationActive: false,
        attributeValueLogicalErrors: [],
        overridableErrors: [],
        overridableErrorCustomHeader: "",
    });

    const promptIfDirty = async () => {
        if (props.isDirty) {
            return notify.confirm("You have unsaved data. Are you sure you want to accept qa?  Unsaved data will be lost!");
        }

        return Promise.resolve(true);
    };

    const finishTask = async (override) => {
        setIsBusy(true);

        if (props.validate) {
            const response = await props.validate(override);

            if (response && response.errors && response.errors.length > 0 && !response.isValid) {
                setIsBusy(false);

                return;
            }

            if (response && response.attributeValueLogicalErrors && !response.isValid) {
                setIsBusy(false);
                setValidation({
                    isValidationConfirmationActive: true,
                    attributeValueLogicalErrors: response.attributeValueLogicalErrors,
                    overridableErrors: response.overridableErrors,
                    overridableErrorCustomHeader: response.overridableErrorCustomHeader ? response.overridableErrorCustomHeader : undefined,
                });

                return;
            }

            if (!response) {
                setIsBusy(false);

                return;
            }
        }

        //If Dirty cancel
        const shouldNavigate = await promptIfDirty();

        if (!shouldNavigate) {
            setIsBusy(false);

            return;
        }

        //Safety Check
        if (props.isQA) {
            const confirmMessage =
                props.acceptPayload && props.acceptPayload.promptText ? props.acceptPayload.promptText : "Are you sure you want to ACCEPT QA?";
            const confirm = await notify.confirm(confirmMessage);

            if (!confirm) {
                setIsBusy(false);

                return;
            }
        }

        const taskId = props.taskId;
        const acceptPayload = props.acceptPayload && props.acceptPayload.payload ? props.acceptPayload.payload : null;
        const action = props.sourcePage ? "complete" : "";
        const response = await completeTask(taskId, false, acceptPayload, props.sourcePage, action);

        if (!response) {
            setIsBusy(false);

            return;
        }

        notify.success("Saved!");

        if (props.onComplete) {
            props.onComplete();
        } else {
            setIsBusy(false);
        }
    };

    const rejectQa = async (e) => {
        e.preventDefault();
        setIsBusy(true);

        if (props.validateReject) {
            const valid = await props.validateReject();

            if (!valid) {
                setIsBusy(false);

                return;
            }
        }

        const taskId = props.taskId;
        const prompt = await dialogConfirm({
            Component: DialogRejectReason,
        });

        if (!prompt.reject) {
            setIsBusy(false);

            return;
        }

        const action = props.sourcePage ? "reject" : "";
        const taskRejectTask = await rejectTask(taskId, props.rejectPayload, props.sourcePage, action);

        if (!taskRejectTask) {
            return;
        }

        const rejectComment = await sendNote({
            items: [
                {
                    noteText: prompt.reason,
                    noteType: "Product",
                    shipmentKey: task.context.shipmentKey,
                    shipmentProductKey: task.context.shipmentProductKey,
                    taskType: props.taskType,
                    sourcePage: props.sourcePage,
                },
            ],
        });

        if (!rejectComment) {
            return;
        }

        notify.success("Task has been rejected");

        if (props.onComplete) {
            props.onComplete();
        } else {
            setIsBusy(false);
        }
    };

    return {
        isBusy,
        finishTask,
        rejectQa,
        validation,
    };
};
